import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { SEOHead } from '@/components/SEOHead'
import { HeroSection } from '@/components/sections/HeroSection'
import { LocalizedLink } from '@/components/LocalizedLink'
import { sectors } from '@/data/sectors'
import type { SupportedLanguage } from '@/i18n'

export function SectorsPage() {
  const { t, i18n } = useTranslation()
  const lang = (i18n.language || 'it') as SupportedLanguage

  return (
    <>
      <SEOHead titleKey="seo.sectors.title" descriptionKey="seo.sectors.description" />

      <HeroSection
        title={t('sectors.heroTitle')}
        subtitle={t('sectors.heroSubtitle')}
        compact
      />

      <section className="section-padding">
        <div className="container-main">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {sectors.map((sector, index) => (
              <motion.div
                key={sector.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
              >
                <LocalizedLink
                  to={`/${lang === 'en' ? 'sectors' : 'settori'}/${sector.slug[lang]}`}
                  className="group relative block h-80 rounded-lg overflow-hidden"
                >
                  <img
                    src={sector.heroImage}
                    alt={t(sector.nameKey)}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-slow"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h2 className="text-white text-2xl font-bold mb-2">{t(sector.nameKey)}</h2>
                    <p className="text-white/70 text-sm mb-3">{t(sector.descriptionKey)}</p>
                    <span className="inline-flex items-center gap-1 text-accent text-sm font-medium group-hover:gap-2 transition-all">
                      {t('buttons.learnMore')} <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </LocalizedLink>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
